var React = require('react');

function CheckNoBackgroundInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.7255 32.1106C13.6159 32.1106 12.5564 31.6285 11.7723 30.778L1.22321 19.2759C-0.407738 17.4976 -0.407738 14.6141 1.22321 12.8358C2.85416 11.0575 5.49872 11.0575 7.12967 12.8358L14.7255 21.1179L32.8703 1.33372C34.5013 -0.444575 37.1458 -0.444575 38.7768 1.33372C40.4077 3.11202 40.4077 5.9955 38.7768 7.7738L17.6787 30.778C16.8945 31.633 15.8309 32.1106 14.7255 32.1106Z","fill":"#10BB73"}));
}

CheckNoBackgroundInline.defaultProps = {"width":"40","height":"33","viewBox":"0 0 40 33","fill":"none"};

module.exports = CheckNoBackgroundInline;

CheckNoBackgroundInline.default = CheckNoBackgroundInline;
